import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";

const AdminLayout = () => {
  return (
    <div className="page">
      <AdminSidebar />
      <div className="page-wrapper">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
